export default "__VITE_ASSET__a66182f0__"